module.exports = __webpack_public_path__ + "static/media/dashboard-menu.48220198.svg";